import { useState } from "react";
import { useQuery } from "react-query";
import { useSnackbar } from "@kitbird/core";
import { jobTItleAPI } from "../../../../services/masterData/jobTitle";

const useJobTitle = () => {
  const snackbar = useSnackbar();
  const [search, setSearch] = useState("");
  const [isLoading, setLoading] = useState(false);
  const [modalFormJobtitle, setModalFormJobTitle] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [valueToEdit, setValueToEdit] = useState<unknown>();

  const { data: dataJobTitles, isLoading: isJobTitlesLoading, refetch } = useQuery({
    queryKey: ["get_job_titles"],
    queryFn: () => jobTItleAPI.getList(),
  });

  const onSubmit = async (value: any) => {
    setLoading(true);
    if (!value?.id) {
      await jobTItleAPI.addJobTitle(value)
        .then((res) => {
          if (res.responseCode === "Succeed") {
            setModalFormJobTitle(false);
            setValueToEdit(undefined);
            refetch();
            snackbar.show("Berhasil menambah data", "success");
          } else snackbar.show(res.responseMessage || "Gagal menambah data", "error");
        })
        .catch(() => snackbar.show("Gagal menambah data", "error"))
        .finally(() => setLoading(false));
    } else {
      await jobTItleAPI.putJobTitle(value)
        .then((res) => {
          if (res.responseCode === "Succeed") {
            setModalFormJobTitle(false);
            setValueToEdit(undefined);
            refetch();
            snackbar.show("Berhasil mengubah data", "success");
          } else snackbar.show(res.responseMessage || "Gagal mengubah data", "error");
        })
        .catch(() => snackbar.show("Gagal mengubah data", "error"))
        .finally(() => setLoading(false));
    }
  };

  return {
    search,
    setSearch,
    isLoading,
    modalFormJobtitle,
    setModalFormJobTitle,
    isEdit,
    setIsEdit,
    valueToEdit,
    setValueToEdit,

    dataJobTitles,
    isJobTitlesLoading,

    onSubmit,
  };
};

export default useJobTitle;
